import { render, staticRenderFns } from "./submitInfo.vue?vue&type=template&id=e3831f10&scoped=true&"
import script from "./submitInfo.vue?vue&type=script&lang=js&"
export * from "./submitInfo.vue?vue&type=script&lang=js&"
import style0 from "./submitInfo.vue?vue&type=style&index=0&id=e3831f10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3831f10",
  null
  
)

export default component.exports